import { createFetchSelector } from '@copilot/common/store/selectors/fetch';
import { SentModel } from '@copilot/data/responses/models/sent';
import { SENT_MESSAGES } from './constant';

export default createFetchSelector<SentModel>(SENT_MESSAGES);
